import { QuestionnaireAnswerType } from 'components/Assessments/types'
import { BradenScaleQuestionnaireItem } from './questionnaire'

// Braden Scale section questionnaire answer type mapping
export const BRADEN_SCALE_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE = {
  [BradenScaleQuestionnaireItem.BRADEN_SCALE_SENSORY_QUESTION]: QuestionnaireAnswerType.CODING,
  [BradenScaleQuestionnaireItem.BRADEN_SCALE_SENSORY_NOTES]: QuestionnaireAnswerType.STRING,
  [BradenScaleQuestionnaireItem.BRADEN_SCALE_MOISTURE_QUESTION]: QuestionnaireAnswerType.CODING,
  [BradenScaleQuestionnaireItem.BRADEN_SCALE_MOISTURE_NOTES]: QuestionnaireAnswerType.STRING,
  [BradenScaleQuestionnaireItem.BRADEN_SCALE_ACTIVITY_QUESTION]: QuestionnaireAnswerType.CODING,
  [BradenScaleQuestionnaireItem.BRADEN_SCALE_ACTIVITY_NOTES]: QuestionnaireAnswerType.STRING,
  [BradenScaleQuestionnaireItem.BRADEN_SCALE_MOBILITY_QUESTION]: QuestionnaireAnswerType.CODING,
  [BradenScaleQuestionnaireItem.BRADEN_SCALE_MOBILITY_NOTES]: QuestionnaireAnswerType.STRING,
  [BradenScaleQuestionnaireItem.BRADEN_SCALE_NUTRITION_QUESTION]: QuestionnaireAnswerType.CODING,
  [BradenScaleQuestionnaireItem.BRADEN_SCALE_NUTRITION_NOTES]: QuestionnaireAnswerType.STRING,
  [BradenScaleQuestionnaireItem.BRADEN_SCALE_FRICTION_AND_SHEAR_QUESTION]:
    QuestionnaireAnswerType.CODING,
  [BradenScaleQuestionnaireItem.BRADEN_SCALE_FRICTION_AND_SHEAR_NOTES]:
    QuestionnaireAnswerType.STRING
}
